import { render, staticRenderFns } from "./Dialogs.vue?vue&type=template&id=1b9309d9&scoped=true&"
import script from "./Dialogs.vue?vue&type=script&lang=js&"
export * from "./Dialogs.vue?vue&type=script&lang=js&"
import style0 from "./Dialogs.vue?vue&type=style&index=0&id=1b9309d9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b9309d9",
  null
  
)

export default component.exports